// Module
var code = `<survey-modal platforms="vm.platforms" survey-manager="vm.surveyManager" is-consent="true" ng-if="vm.projectId || vm.linkKey"></survey-modal>`;
// Exports
export default code;